import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=5f824adc&scoped=true"
import script from "./ChannelInfo.vue?vue&type=script&lang=js"
export * from "./ChannelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f824adc",
  null
  
)

export default component.exports